import { FunctionalComponent } from "preact";
import { useState, useEffect } from "preact/hooks";

interface LoginModalProps {
  onLogin: (apiKey: string) => void;
}

export const LoginModal: FunctionalComponent<LoginModalProps> = ({ onLogin }) => {
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const savedKey = localStorage.getItem("pbookmarks_api_key");
    if (savedKey) {
      setApiKey(savedKey);
    }
  }, []);

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    if (!apiKey.trim()) {
      setError("API key is required");
      return;
    }
    localStorage.setItem("pbookmarks_api_key", apiKey.trim());
    onLogin(apiKey.trim());
  };

  return (
    <div class="fixed inset-0 z-50 overflow-y-auto">
      <div class="flex min-h-screen items-center justify-center p-4">
        <div class="fixed inset-0 bg-black/50" />
        <div class="relative bg-white dark:bg-stone-900 rounded-2xl shadow-2xl max-w-md w-full p-10 border border-stone-200 dark:border-stone-800">
          <div class="text-center mb-10">
            <div class="mx-auto h-16 w-16 bg-primary-100 dark:bg-primary-900/30 rounded-2xl flex items-center justify-center mb-6">
              <svg
                class="h-8 w-8 text-primary-600 dark:text-primary-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
                />
              </svg>
            </div>
            <h2 class="text-3xl font-display font-bold text-stone-900 dark:text-stone-50">
              Welcome
            </h2>
            <p class="mt-3 text-stone-500 dark:text-stone-400 font-serif text-lg">
              Enter your API key to enter the reading room.
            </p>
          </div>

          <form onSubmit={handleSubmit} class="space-y-6">
            {error && (
              <div class="p-4 rounded-xl bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400 text-sm border border-red-100 dark:border-red-900/30">
                {error}
              </div>
            )}

            <div class="space-y-2">
              <label class="block text-sm font-semibold text-stone-700 dark:text-stone-300">
                API Key
              </label>
              <input
                type="password"
                value={apiKey}
                onInput={(e) => setApiKey((e.target as HTMLInputElement).value)}
                placeholder="Enter your API key"
                class="w-full px-4 py-3 border border-stone-200 dark:border-stone-800 rounded-xl bg-white dark:bg-stone-950 text-stone-900 dark:text-stone-100 focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 transition-all shadow-sm"
              />
            </div>

            <button
              type="submit"
              class="w-full px-6 py-3 bg-primary-600 text-white rounded-xl hover:bg-primary-700 shadow-md hover:shadow-lg transition-all font-bold text-lg"
            >
              Access Bookmarks
            </button>
          </form>

          <p class="mt-8 text-xs text-center text-stone-400 dark:text-stone-500">
            Your key is stored locally and never shared.
          </p>
        </div>
      </div>
    </div>
  );
};
